import React, { useState, useEffect } from "react";

import {
  CCard,
  CCardHeader,
  CCardFooter,
  CCol,
  CLink,
  CRow
} from "@coreui/react";
import {
  RiAttachmentLine,
  RiCheckboxCircleLine,
  RiFileList2Line,
  RiTeamLine
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import ImgNoData from "../../../assets/imgs/graduation.svg";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import Loading from "../../Loading";
import SwitchButton from "../../SwitchButton";
import { TrailDashBoardItem } from "../../TrailDashboardItem";

const DashboardTrailStudent = props => {
  const tutorialModalStored = localStorage.getItem(
    `${props.user.user?.id ? props.user.user?.id : ""}tutorialModalClosed`
  );
  const tutorialModal = tutorialModalStored
    ? JSON.parse(tutorialModalStored)
    : false;

  const [classrooms, setClassrooms] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [primaryColor, setPrimaryColor] = useState(null);
  const [secondaryColor, setSecondaryColor] = useState(null);
  const [grayColor, setGrayColor] = useState(null);
  const [trails, setTrails] = useState(undefined);
  const [activeTrails, setActiveTrails] = useState(undefined);
  const [modal, setModal] = useState(!tutorialModal);

  const root = document.documentElement;

  useEffect(() => {
    pullDashboard();
  }, []);

  useEffect(() => {
    root?.style.setProperty(
      "--primary-group-change",
      primaryColor != null ? primaryColor : ""
    );
    root?.style.setProperty(
      "--secondary-group-change",
      secondaryColor != null ? secondaryColor : ""
    );
    root?.style.setProperty(
      "--primary-grey-group-change",
      grayColor != null ? grayColor : ""
    );
  }, [primaryColor, secondaryColor, grayColor]);

  const pullDashboard = async () => {
    try {
      const id = props.general.active_roles.group_id;
      const schoolId = props.general.active_roles.school_id;

      const isSchoolsInTrail = schoolId === 7883 || schoolId === 7919;

      const groupSingleViewResponse = await axios.get(
        `${URL.api}access/group/singleView/${id}`,
        {
          headers: { authorization: `Bearer ${props.user.token}` }
        }
      );
      setPrimaryColor(groupSingleViewResponse.data.data.group.primary);
      setSecondaryColor(groupSingleViewResponse.data.data.group.secondary);
      setGrayColor(groupSingleViewResponse.data.data.group.primary_grey);

      const userProgressResponse = await axios.get(
        `${URL.api}activity/trail/userProgressList?`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );
      setActiveTrails(userProgressResponse.data.data);
      setTrails(userProgressResponse.data.data);

      const classroomListResponse = await axios.get(
        `${URL.api}community/room_user/listRoomsByUser?page=1&page_size=6`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );
      setClassrooms(classroomListResponse.data.data);

      const communitiesListResponse = await axios.get(
        `${URL.api}community/room/getCommunitiesByUser`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );
      const fileteredCommunities = communitiesListResponse.data.data.filter(
        community => community.type !== "closed"
      );

      setCommunities(fileteredCommunities);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("Não foi possível se comunicar com a plataforma!");
    }
  };

  const newError = response => {
    if (response === "Unauthorized") {
      props.logout(props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  const closeModal = () => {
    localStorage.setItem(
      `${props.user.user?.id ? props.user.user?.id : ""}tutorialModalClosed`,
      true
    );
    setModal(false);
  };

  return (
    <div className="container w-100">
      <Modal isOpen={modal} toggle={closeModal} className="educandus">
        <ModalHeader toggle={closeModal}>
          Conhecendo nossas Trilhas de Aprendizagem
        </ModalHeader>
        <ModalBody>
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/bnmEGz0d6U0?si=4szOLVTQUwK3Rq2c"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </ModalBody>
      </Modal>
      <CRow className=" mb-3">
        <CCol xs="12" lg="9" xxl="8">
          <h2 className="font-weight-bold text-title mb-3">Minhas trilhas</h2>
          <div className="d-flex flex-wrap mb-3">
            <SwitchButton
              text="Todas"
              icon={<RiFileList2Line />}
              className="mr-3 mb-2"
              onClick={() => setActiveTrails(trails)}
            />
            <SwitchButton
              text="Concluídas"
              icon={<RiCheckboxCircleLine />}
              className="mb-2"
              onClick={() =>
                setActiveTrails(trails.filter(trail => trail.progress >= 100))
              }
            />
          </div>
          {activeTrails ? (
            activeTrails.length > 0 ? (
              <>
                {activeTrails?.map((trail, index) => (
                  <CLink
                    to={`trail/do/${trail.trail_allocation_id}?partialprogression=${trail.is_partial_progression}`}
                    className="text-decoration-none"
                  >
                    <TrailDashBoardItem
                      key={index}
                      title={trail.name}
                      image={trail.image}
                      progress={trail.progress}
                      partialProgression={trail.is_partial_progression}
                      trailAllocationId={trail.trail_allocation_id}
                      clickableStep
                    />
                  </CLink>
                ))}
              </>
            ) : (
              <div className="justify-content-center align-items-center d-flex flex-column my-5">
                <img
                  src={ImgNoData}
                  style={{ height: "240px", marginBottom: "2rem" }}
                  alt=""
                />
                <p
                  style={{ fontSize: "1.5rem" }}
                  className="mb-2 font-weight-bold text-center"
                >
                  Você não possui nenhuma trilha disponível no momento.
                </p>
                <span className="text-muted text-center">
                  Qualquer dúvida ou se precisar de ajuda, não hesite em nos
                  contatar pelo suporte!
                </span>
              </div>
            )
          ) : (
            <div className="p-4">
              <Loading />
            </div>
          )}{" "}
        </CCol>
        <CCol xs="12" lg="3" xxl="4">
          <div className="w-100">
            {classrooms.length > 0 && activeTrails && (
              <>
                <h2 className="font-weight-bold text-title mb-3">
                  Minhas Turmas
                </h2>
                <CRow>
                  {classrooms.map(classroom => (
                    <CCol xxl="6" key={classroom.id}>
                      <CCard>
                        <CCardHeader className="bg-lightblue text-title d-flex flex-column py-2">
                          <CLink
                            to={`/classroom/${classroom.id}`}
                            className="text-title mt-1"
                          >
                            <h5 className="mb-1 text-ellipsis font-weight-semibold">
                              {classroom.name}
                            </h5>
                          </CLink>
                          <div className="small mb-1">
                            {classroom.school_name}
                          </div>
                        </CCardHeader>
                        <CCardFooter className="d-flex text-title py-2">
                          <span className="mr-3" style={{ flex: 1 }}>
                            <RiTeamLine className="mr-2" />
                            {classroom.num_users}
                          </span>
                          <CLink
                            className="mr-3 text-title"
                            to={`/classroom/${classroom.id}/activities`}
                          >
                            <RiFileList2Line />
                          </CLink>
                          <CLink
                            to={`/classroom/${classroom.id}/docs`}
                            className="text-title"
                          >
                            <RiAttachmentLine />
                          </CLink>
                        </CCardFooter>
                      </CCard>
                    </CCol>
                  ))}
                </CRow>
              </>
            )}
            {communities.length > 0 && (
              <>
                <h2 className="font-weight-bold text-title mb-3">
                  Minhas Comunidades
                </h2>
                <CRow>
                  {communities.map(room => (
                    <CCol xxl="6" key={room.id}>
                      <CCard>
                        <CCardHeader className="bg-lightblue text-title d-flex flex-column py-2">
                          <CLink
                            to={`/room/${room.id}`}
                            className="text-title my-1"
                          >
                            <h5 className="mb-0 text-ellipsis font-weight-semibold">
                              {room.name}
                            </h5>
                          </CLink>
                        </CCardHeader>
                        <CCardFooter className="d-flex text-title border-0 py-2">
                          <span className="mr-3" style={{ flex: 1 }}>
                            <RiTeamLine className="mr-2" />
                            {room.num_users}
                          </span>
                          <CLink
                            to={`/room/${room.id}/docs`}
                            className="text-title"
                          >
                            <RiAttachmentLine />
                          </CLink>
                        </CCardFooter>
                      </CCard>
                    </CCol>
                  ))}
                </CRow>
              </>
            )}
          </div>
        </CCol>
      </CRow>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardTrailStudent);
